export const categories = [
  {
    slug: "entertainment",
    name: "娱乐",
    description: "汇聚搞笑短剧、音乐现场与脱口秀精选，轻松一刻从这里开始。",
    icon: "ri-emotion-happy-line",
  },
  {
    slug: "life",
    name: "生活",
    description: "生活方式、收纳整理与萌宠日常，记录真实而温暖的每一天。",
    icon: "ri-home-smile-line",
  },
  {
    slug: "education",
    name: "教育",
    description: "语言学习、思维启蒙与趣味科普，用视频让知识变得更好懂。",
    icon: "ri-book-open-line",
  },
  {
    slug: "tech",
    name: "科技",
    description: "前沿科技、数码评测与智能生活，第一时间看懂技术趋势。",
    icon: "ri-cpu-line",
  },
  {
    slug: "music",
    name: "音乐",
    description: "纯音乐、民谣弹唱与现场演绎，用耳朵感受旋律的温度。",
    icon: "ri-music-2-line",
  },
  {
    slug: "sports",
    name: "体育",
    description: "马拉松、球类赛事与运动集锦，感受竞技体育的热血瞬间。",
    icon: "ri-basketball-line",
  },
  {
    slug: "food",
    name: "美食",
    description: "家常菜谱、烘焙过程与街头探店，让每一口都充满期待。",
    icon: "ri-restaurant-2-line",
  },
  {
    slug: "travel",
    name: "旅行",
    description: "山海日出、自驾公路与古镇漫步，带你云游世界各地风光。",
    icon: "ri-flight-takeoff-line",
  },
];